import { getUserId, getLoginId, getMemberUserId } from '@/services/methods/user'
import { RequestConfig } from '@/services/http/types'
import service from '@/services'
import http from '@/services/http'

/**
 * 获取应用配置信息
 */
// export function getAppConfig() {
//     return http.request<Model.AppConfig>({
//         url: './config/appconfig.json',
//     })
// }

/**
 * 获取服务器时间
 */
export function getServerTime(config: RequestConfig = {}) {
    return http.commonRequest<string>({
        url: '/Common/GetServerTime',
        params: config.data,
    })
}

/**
 * 获取应用更新信息
 */
export function getAppUpdateInfo(config: RequestConfig = {}) {
    return http.request<string>({
        url: service.getConfig('androidUpdateUrl'),
        params: config.data,
    })
}

/**
 * 用户注册
 */
export function userRegister(config: RequestConfig<Model.RegisterReq> = {}) {
    return http.request<Model.RegisterRsp>({
        method: 'post',
        url: service.getConfig('openApiUrl') + '/onlineopen/userInfo/add3',
        data: config.data,
    })
}

/**
 * 发送注册短信验证码
 */
export function sendRegisterVerifyCode(config: RequestConfig<{ phonenumber: string }> = {}) {
    return http.request({
        url: service.getConfig('openApiUrl') + '/verifycode/identifyCode/' + config.data?.phonenumber,
    })
}

/**
 * 重置密码
 */
export function resetPassword(config: RequestConfig<Model.ResetPasswordReq> = {}) {
    return http.request<Model.ResetPasswordRsp>({
        method: 'post',
        url: service.getConfig('commSearchUrl') + '/tradeoperation/resetpwdbycardnum',
        data: config.data,
    })
}

/**
 * 发送重置密码短信验证码
 */
export function sendResetVerifyCode(config: RequestConfig<Model.SendResetVerifyCodeReq> = {}) {
    return http.request<Model.SendResetVerifyCodeRsp>({
        method: 'post',
        url: service.getConfig('commSearchUrl') + '/user/smsvcode',
        data: config.data,
    })
}

/**
 * 文件上传
 */
export function uploadFile(config: RequestConfig<Model.uploadFileReq> = {}) {
    return http.request<Model.uploadFileRsp>({
        method: 'post',
        url: service.getConfig('uploadUrl'),
        data: config.data,
    })
}

/**
 * 查询轮播图配置信息
 */
export function queryImageConfigs(config: RequestConfig<Model.ImageConfigsReq> = {}) {
    return http.commonRequest<Model.ImageConfigsRsp[]>({
        url: '/Common/QueryImageConfigs',
        params: config.data,
    })
}

/**
 * 查询所有枚举信息
 */
export function queryAllEnums(config: RequestConfig<Model.EnumReq> = {}) {
    return http.commonRequest<Model.EnumRsp[]>({
        url: '/Common/GetAllEnums',
        params: config.data,
    }, 'GetAllEnums')
}

/**
 * 获取枚举项字典扩展表信息
 */
export function getI18nConfigs(config: RequestConfig<Model.EnumReq> = {}) {
    return http.commonRequest<Model.I18nConfigsRsp[]>({
        url: '/Common/GetI18nConfigs',
        params: config.data,
    }, 'GetI18nConfigs')
}

/**
 * 获取数据库错误信息
 */
export function queryErrorInfos(config: RequestConfig<Model.ErrorInfosReq> = {}) {
    return http.commonRequest<Model.ErrorInfosRsp[]>({
        url: '/Common/QueryErrorInfos',
        params: config.data,
    }, 'QueryErrorInfos')
}

/**
 * 用户签到
 * signinstatus 状态操作标志 1-签到成功 2-当日已签到，不能重复签到
 */
export function signin(config: RequestConfig<{ userid: number }> = {}) {
    return http.commonRequest<{ signinstatus: number }>({
        method: 'post',
        url: '/Ferroalloy/Signin',
        data: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询我的注册红包
 */
export function queryMyRegisterMoney(config: RequestConfig<Model.MyRegisterMoneyReq> = {}) {
    return http.commonRequest<Model.MyRegisterMoneyRsp[]>({
        url: '/Ferroalloy/QueryMyRegisterMoney',
        params: config.data,
    })
}

/**
 * 查询用户等级信息
 */
export function queryUserLevelInfo(config: RequestConfig<Model.UserLevelInfoReq> = {}) {
    return http.commonRequest<Model.UserLevelInfoRsp>({
        url: '/Ferroalloy/QueryUserLevelInfo',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询查询我推荐的好友等级
 */
export function queryInvestorLevelGroup(config: RequestConfig = {}) {
    return http.commonRequest<Model.InvestorLevelGroupRsp[]>({
        url: '/Ferroalloy/QueryInvestorLevelGroup',
        params: config.data,
    })
}

/**
 * 查询好友
 */
export function queryTHJFriends(config: RequestConfig<Model.THJFriendsReq> = {}) {
    return http.commonRequest<Model.THJFriendsRsp[]>({
        url: '/Ferroalloy/QueryTHJFriends',
        params: config.data,
    })
}

/**
 * 查询收益
 */
export function queryTHJProfits(config: RequestConfig<Model.THJProfitsReq> = {}) {
    return http.commonRequest<Model.THJProfitsRsp[]>({
        url: '/Ferroalloy/QueryTHJProfits',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 查询本人定金比例
 */
export function queryMyDeposit(config: RequestConfig<Model.MyDepositReq> = {}) {
    return http.commonRequest<Model.MyDepositRsp[]>({
        url: '/Ferroalloy/QueryMyDeposit',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 定金比例个性化查询
 */
export function queryTHJinvesotrdeposit(config: RequestConfig<Model.THJinvesotrdepositReq> = {}) {
    return http.commonRequest<Model.THJinvesotrdepositRsp[]>({
        url: '/Ferroalloy/QueryTHJinvesotrdeposit',
        params: {
            userid: getUserId(),
            ...config.data
        },
    })
}

/**
 * 比例变更流水查询
 */
export function queryTHJInvesotrDepositLog(config: RequestConfig<Model.THJInvesotrDepositLogReq> = {}) {
    return http.commonRequest<Model.THJInvesotrDepositLogRsp[]>({
        url: '/Ferroalloy/QueryTHJInvesotrDepositLog',
        params: config.data,
    })
}

/**
 * 通知公告系统消息查询
 */
export function queryNotice(config: RequestConfig<Model.NoticeReq> = {}) {
    return http.commonRequest<Model.NoticeRsp[]>({
        url: '/Common/QueryNotice',
        params: {
            loginID: getLoginId(),
            ...config.data
        },
    })
}

/**
 * 通知公告设置已读
 */
export function postNoticeReaded(config: RequestConfig<Model.NoticeReadedReq> = {}) {
    return http.commonRequest({
        method: 'post',
        url: '/Common/NoticeReaded',
        data: {
            loginID: getLoginId(),
            ...config.data
        },
    })
}

/**
 * 获取金10资讯数据
 */
export function getJ10News(config: RequestConfig<Model.J10NewsReq> = {}) {
    return http.commonRequest<Model.J10NewsRsp[]>({
        url: '/Common/GetJ10News',
        params: config.data,
    })
}

/**
 * 查询会员商品限制配置表
 */
export function queryMemberGoodsLimitConfig(config: RequestConfig<Model.MemberGoodsLimitConfigReq> = {}) {
    return http.commonRequest<Model.MemberGoodsLimitConfigRsp[]>({
        url: '/Common/QueryMemberGoodsLimitConfig',
        params: {
            userid: getMemberUserId(),
            ...config.data
        }
    })
}

/**
 * 查询区域信息
 */
export function getDivisions(config: RequestConfig = {}) {
    return http.commonRequest<Model.Region[]>({
        url: '/Common/GetDivisions',
        params: config.data,
    })
}

/**
 * 获取系统参数信息
 */
export function fetchSystemParams(config: RequestConfig = {}) {
    return http.commonRequest<Model.SystemParam[]>({
        url: '/Common/GetSystemParams',
        params: config.data,
    })
}

/**
 * 获取终端文档配置信息
 */
export function getClientDocumnetConfigs(config: RequestConfig = {}) {
    return http.commonRequest<Model.DocumnetConfigsRsp[]>({
        url: '/Common/GetClientDocumnetConfigs',
        params: config.data,
    })
}